import { formValueSelector } from 'redux-form'
import { FormAdapter } from 'core/utils/adapters'
import { ShortEntityResponse } from 'reducers/Reducers.interfaces'
import { IFormStep } from 'shared/components/form-steps/FormSteps'
import { translate } from 'shared/helpers/utils'

export const UserFormFields = {
  firstName: 'first_name',
  lastName: 'last_name',
  login: 'login',
  email: 'email',
  username: 'user_name',
  samlUsername: 'saml_username',
  oidcUsername: 'oidc_username',
  phone: 'phone',
  accessScope: 'access_scope',
  tenants: 'tenants',
  accounts: 'accounts',
  permissions: 'permissions',
  users: 'users',
  user: 'user',
  language: 'language'
}

export const UserFormAdapter = new FormAdapter(UserFormFields, 'userForm')

export const userFormSelector = formValueSelector(UserFormAdapter.name)

export const getUserFormSteps = (permissions: ShortEntityResponse[]): IFormStep[] => [
  { id: '1', fieldName: UserFormFields.firstName, fieldLabel: 'common.form.first_name' },
  { id: '1', fieldName: UserFormFields.lastName, fieldLabel: 'common.form.last_name' },
  { id: '1', fieldName: UserFormFields.email, fieldLabel: 'common.form.email' },
  { id: '1', fieldName: `${UserFormFields.accessScope}.name`, fieldLabel: 'manageUser.administrators.form.accessScope' },
  { id: '1',
    fieldName: UserFormFields.phone,
    fieldLabel: 'common.form.phone'
  },
  {
    id: '2',
    fieldName: UserFormFields.permissions,
    fieldLabel: 'common.form.permissions',
    parseValue: (formValues) => {
      if (formValues && formValues.permissions) {
        return Object.keys(formValues.permissions)
          .filter(permissionId => formValues.permissions[permissionId])
          .map(permissionId => {
            const permission = permissions.find(p => p.id === permissionId)
            return permission ? translate(`permissions.${permission.name}`) : ''
          })
          .join(', ')
      }

      return ''
    }
  }
]
